import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@hbs-us/ui';

const STORAGE_KEY = 'qelm-dashboard-locale';
const DEFAULT_LOCALE: SupportedLanguage = 'en';

/**
 * Allowlist validation — the persisted locale is untrusted client-controlled
 * input read on every boot (threat T-21G-06). Only `en`/`es` are honoured; any
 * tampered/unknown value falls back to the default.
 */
export function isSupportedLanguage(value: string | null): value is SupportedLanguage {
  return value != null && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** Read the stored locale, allowlist-validated. SSR-safe. */
export function readStoredLocale(): SupportedLanguage {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return isSupportedLanguage(stored) ? stored : DEFAULT_LOCALE;
}

/** Persist the chosen locale. SSR-safe. */
export function setStoredLocale(lang: SupportedLanguage): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, lang);
}
